module.exports = __webpack_public_path__ + "static/fonts/SourceSansPro-LightItalic.8e29f0c.eot";